"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  compositions: {
    core: {
      error: {
        defaultMessage: 'Something went wrong',
        goBackButton: 'Go back'
      }
    }
  }
});